import DynamicChatRoomThread from "%/dynamic-component-editor/standard-pages/chat-room-page/DynamicChatRoomThread.vue";
import ListOfExclusiveChannels from "%/dynamic-component-editor/standard-elements/list-of-channels/ListOfExclusiveChannels.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyExclusiveChatRoom extends LegacyEntity {
  get elements() {
    return {
      DynamicChatRoomThread,
      ListOfExclusiveChannels,
    };
  }
}
